<div class="my-2 px-2">
  <div class="mb-2 flex justify-between">
    <h1 class="text-lg font-semibold">Sản phẩm Nutriday Quốc Tế</h1>
    <a
      class="btn btn-ghost btn-xs text-sm text-slate-400"
      [routerLink]="['/products']"
      [queryParams]="{
        types: [PRODUCT_TYPE.vip, PRODUCT_TYPE.retail, PRODUCT_TYPE.shop]
      }">
      Xem thêm
    </a>
  </div>
  <div class="bg-base-200 px-1 py-2">
    <market-carousel-wrapper [options]="options">
      <li class="splide__slide">
        <a
          class="block cursor-pointer overflow-hidden"
          [routerLink]="['/products']"
          [queryParams]="{ types: PRODUCT_TYPE.vip }">
          <div class="mx-auto w-fit">
            <img
              class="h-24 w-24 rounded object-cover"
              src="assets/images/nutriday/1.png"
              [alt]="'vip'"
              marketImageFailed />
          </div>
          <p class="block w-full text-center text-sm font-semibold">
            Khách hàng thân thiết
          </p>
        </a>
      </li>
      <li class="splide__slide">
        <a
          class="block cursor-pointer overflow-hidden"
          [routerLink]="['/products']"
          [queryParams]="{ types: PRODUCT_TYPE.retail }">
          <div class="mx-auto w-fit">
            <img
              class="h-24 w-24 rounded object-cover"
              src="assets/images/nutriday/2.png"
              [alt]="'retail'"
              marketImageFailed />
          </div>
          <p class="block w-full text-center text-sm font-semibold">
            Nhà bán lẻ
          </p>
        </a>
      </li>
      <li class="splide__slide">
        <a
          class="block cursor-pointer overflow-hidden"
          [routerLink]="['/products']"
          [queryParams]="{ types: PRODUCT_TYPE.shop }">
          <div class="mx-auto w-fit">
            <img
              class="h-24 w-24 rounded object-cover"
              src="assets/images/nutriday/3.png"
              [alt]="'shop'"
              marketImageFailed />
          </div>
          <p class="block w-full text-center text-sm font-semibold">
            Dành cho đại lý
          </p>
        </a>
      </li>
    </market-carousel-wrapper>
  </div>
</div>
